import * as Yup from "yup";

export const getValidationSchema = () => {
  return Yup.object({
    alias: Yup.string().required("Please select a Target Account"),
    s3Bucket: Yup.string().required("Please select a S3 Bucket"),
  });
};
